import React from "react";
import ReactApexChart from "react-apexcharts";

const SemicircularChart = ({ seriesData, colorsData, trackBackground, centerLabel }) => {
  const options1 = {
    chart: {
      type: "radialBar",
      height: 160,
      sparkline: { enabled: true },
      toolbar: { show: false },
    },
    series: [seriesData],
    colors: [colorsData],
    plotOptions: {
      radialBar: {
        startAngle: -135,
        endAngle: 135,
        hollow: {
          size: "58%",
          background: "transparent",
        },
        track: {
          background: trackBackground,
          startAngle: -135,
          endAngle: 135,
          strokeWidth: "100%",
          margin: 0,
        },
        dataLabels: {
          name: { show: false },
          value: {
            fontSize: "1rem",
            fontWeight: 700,
            fontFamily: "inherit",
            color: "#111",
            offsetY: 5,
            show: true,
            formatter: (value) =>
              centerLabel !== undefined ? String(centerLabel) : `${value}%`,
          },
        },
      },
    },
    stroke: {
      lineCap: "round",
    },
    // react-apexcharts redraws only when options/series change as JSON, which
    // drops the formatter. Carry the center number here too, so a new count
    // with the same arc (Total is always 100%) still redraws.
    labels: [centerLabel !== undefined ? String(centerLabel) : "Progress"],
  };

  return (
    <div style={{ margin: "0 auto" }}>
      <ReactApexChart
        options={options1}
        series={options1.series}
        type="radialBar"
        height={160}
      />
    </div>
  );
};

export default SemicircularChart;
